import axios from "axios";
// import dotenv from 'dotenv'

// dotenv.config()
console.log(process.env)
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_BACK_SRC + '/api', 
});

export default axiosInstance;